import React from 'react';
import classnames from 'classnames';

import styles from './footer-button.module.css';
import Message from '../../Message';
import { ButtonPrimary } from '@uberall/zenit';
import { buttonOrAnchorProp } from '../types';

type FooterButtonProps = {
    className?: string;
    code: string;
    buttonProps?: buttonOrAnchorProp;
};

const FooterButton = ({ className, code, buttonProps }: FooterButtonProps) => (
    <ButtonPrimary
        className={classnames(styles.footerButton, className, {
            [styles.disabled]: buttonProps?.disabled,
        })}
        {...buttonProps}
    >
        <Message code={code} />
    </ButtonPrimary>
);

export default FooterButton;
